<script lang="ts">
  let { poster, backdrop, title = '', busy = true }: { poster?: string; backdrop?: string; title?: string; busy?: boolean } = $props();
  let failed = $state(false);
  $effect(() => { void backdrop; void poster; failed = false; });
</script>
<div class="artwork-waiting" aria-busy={busy} aria-label={title ? `${title} artwork` : 'Video artwork'}>
  {#if (backdrop || poster) && !failed}<img src={backdrop || poster} alt="" onerror={() => { failed = true; }} />{/if}
  <div class="veil" aria-hidden="true"></div>
</div>
<style>
  .artwork-waiting { position: absolute; inset: 0; overflow: hidden; background: var(--bg); }
  img { width: 100%; height: 100%; object-fit: cover; object-position: center; }
  .veil { position: absolute; inset: 0; background: rgb(0 0 0 / .42); }
</style>
